import React from "react";

const SvgBBiconsPlus = props => (
  <svg viewBox={props.viewBox ? props.viewBox : "0 0 200 200"} {...props}>
    <path
      d="M165.4 92.27h-56v-56a9 9 0 00-18 0v56h-56a9 9 0 100 18h56v56a9 9 0 0018 0v-56h56a9 9 0 000-18z"
      data-name="Obecn\xE9 ikony"
    />
  </svg>
);

export default SvgBBiconsPlus;

